import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const COOKIE_CONSENT_KEY = 'standby_cookie_consent';

export const CookieConsent = () => {
  const { t } = useTranslation();
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) setShow(true);
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setShow(false);
    // Reload so GTM/GA scripts load (they check consent on page load)
    window.location.reload();
  };

  const decline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setShow(false);
    // No reload needed — scripts are already not loaded on first visit
    // On next page load, the head script checks consent and won't load tracking
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-[16px] md:p-[24px]">
      <div className="max-w-[600px] mx-auto bg-white dark:bg-[#1C1C1F] rounded-[16px] border border-[#E5E5ED] dark:border-[rgba(255,255,255,0.08)] shadow-[0_8px_30px_rgba(0,0,0,0.12)] p-[20px]">
        <p className="font-body text-[14px] text-[#374151] dark:text-[#A0A0A3] leading-relaxed mb-[16px]">
          {t('cookie.message')}{' '}
          <Link to="/privacy" className="text-base-black dark:text-white font-semibold underline">
            {t('footer.privacy')}
          </Link>{' '}
          {t('cookie.forDetails')}
        </p>
        <div className="flex gap-[8px]">
          <button
            type="button"
            onClick={accept}
            className="h-[40px] px-[20px] rounded-[32px] bg-[#1D1D1E] dark:bg-[#C8C8CB] text-white dark:text-[#1C1C1F] font-body text-[13px] font-medium hover:bg-[#2E2E30] dark:hover:bg-[#D8D8DB] transition-all"
          >
            {t('cookie.accept')}
          </button>
          <button
            type="button"
            onClick={decline}
            className="h-[40px] px-[20px] rounded-[32px] border border-gray-500 dark:border-[rgba(255,255,255,0.08)] bg-gray-400 dark:bg-[#28282B] font-body text-[13px] font-medium text-base-black dark:text-white hover:bg-[#E0E0E3] dark:hover:bg-[#333336] transition-all"
          >
            {t('cookie.decline')}
          </button>
        </div>
      </div>
    </div>
  );
};
